import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

@Pipe({
  name: 'momentDate',
  pure: true
})
export class MomentDatePipe implements PipeTransform {
  transform(
    value: moment.Moment | string | null | undefined,
    format?: string,
    isUtc?: boolean
  ): string {
    if (!value) {
      return '';
    }
    const momentDate = isUtc ? moment.utc(value) : moment.parseZone(value);
    if (!momentDate.isValid()) {
      return '';
    }
    return momentDate.format(format);
  }
}
